import React, { useEffect, useState } from 'react';
import { Phone, Snowflake, Menu, X } from 'lucide-react';
import { NAV_LINKS, PHONE, PHONE_HREF } from '../mock';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'backdrop-blur-md bg-[#090C13]/85 border-b border-[var(--line)]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-3 group">
          <span className="w-9 h-9 rounded-md bg-[var(--accent)] flex items-center justify-center shrink-0">
            <Snowflake size={18} className="text-white" strokeWidth={2.4} />
          </span>
          <span className="leading-none">
            <span className="block font-display text-[17px] tracking-tight">CoolTrace</span>
            <span className="label-mono text-[var(--muted)] text-[0.58rem]">Solutions</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="label-mono text-[var(--muted)] hover:text-white transition-colors link-sweep"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={PHONE_HREF}
            className="btn-accent hidden sm:flex items-center gap-2 rounded-md px-4 py-2.5 label-mono tracking-[0.14em] text-[0.72rem]"
          >
            <Phone size={14} strokeWidth={2.4} />
            {PHONE}
          </a>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#090C13]/95 backdrop-blur-md border-b border-[var(--line)] px-6 py-6 flex flex-col gap-5">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="label-mono text-[var(--muted)] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href={PHONE_HREF} className="btn-accent flex items-center justify-center gap-2 rounded-md px-4 py-3 label-mono text-[0.72rem]">
            <Phone size={14} /> {PHONE}
          </a>
        </div>
      )}
    </header>
  );
}
